export enum CatalogItemType {
  Film = 0,
  Serial = 1,
  Show = 2,
  KinoStories = 3,
  Documentary = 4,
  FeatureFilm = 5,
}

export const GenreMap = new Map([
  [0, 'Авантюрный'],
  [1, 'Анимационный'],
  [2, 'Военный'],
  [3, 'Документальный'],
  [4, 'Исторический'],
  [5, 'Криминальный'],
  [6, 'Музыкальный'],
  [7, 'Молодёжный'],
  [8, 'Спортивный'],
  [9, 'Боевик'],
  [10, 'Детектив'],
  [11, 'Драма'],
  [12, 'Драмеди'],
  [13, 'Комедия'],
  [14, 'Комикс'],
  [15, 'Мелодрама'],
  [16, 'Мистика'],
  [17, 'Триллер'],
  [18, 'Фантастика'],
  [19, 'Фэнтези'],
  [20, 'Хоррор'],
])
